import React from "react";
import "../landing.css";

const INFO = () => {
  return (
    <div className="landing-section-info">
      <div className="landing-section-info-text">
        MINDSAI Co., Ltd
        <br />
        #3F, 155, Dogok-ro, Gangnam-gu, Seoul, Republic of Korea (Yeoksam-dong,
        Myung BLDG.)
        <br />
        Business Registration Certificate : 180-86-01522 | Mail-order Business
        Declaration : No.2020-SEOULGANGNAM-02788
      </div>
    </div>
  );
};

export default INFO;
